import { pick } from 'lodash/object';

export const PAYMENT_NETWORKS = {
  ACH_DASH: 'ACH_DASH',
  ACH_FINIX: 'ACH_FINIX',
  ACH_TREMENDOUS: 'ACH_TREMENDOUS',
  AMAZON_BALANCE: 'AMAZON_BALANCE',
  BASS_PRO_SHOPS: 'EGIFT_BLACKHAWK_BASSPROSHOPS',
  BEST_BUY: 'EGIFT_BLACKHAWK_BESTBUY',
  EGIFT_BLACKHAWK_AMAZON: 'EGIFT_BLACKHAWK_AMAZON',
  EGIFT_BLACKHAWK_GAP: 'EGIFT_BLACKHAWK_GAP',
  EGIFT_BLACKHAWK_NIKE: 'EGIFT_BLACKHAWK_NIKE',
  EGIFT_BLACKHAWK_SAFEWAY: 'EGIFT_BLACKHAWK_SAFEWAY',
  EGIFT_BLACKHAWK_SUBWAY: 'EGIFT_BLACKHAWK_SUBWAY',
  EGIFT_BLACKHAWK_TARGET_CLASSACTION: 'EGIFT_BLACKHAWK_TARGET_CLASSACTION',
  EGIFT_BLACKHAWK_WALMART: 'EGIFT_BLACKHAWK_WALMART',
  EGIFT_BLACKHAWK_WHOLEFOODS: 'EGIFT_BLACKHAWK_WHOLEFOODS',
  EGIFT_TREMENDOUS_AMAZON: 'EGIFT_TREMENDOUS_AMAZON',
  JETBLUE_TRAVEL_BANK: 'JETBLUE_TRAVEL_BANK',
  MASTERCARD: 'VIRTUALDEBITCARD_BLACKHAWK_MASTERCARD',
  OCT_FINIX: 'OCT_FINIX',
  OFFICE_DEPOT: 'EGIFT_BLACKHAWK_OFFICEDEPOT',
  PAPER_CHECK: 'PAPER_CHECK',
  PAYPAL_ADAPTIVE_PAYMENTS: 'PAYPAL_ADAPTIVE_PAYMENTS',
  PAYPAL_DASH: 'PAYPAL_DASH',
  PAYPAL_PAYOUTS: 'PAYPAL_PAYOUTS',
  PAYPAL_TREMENDOUS: 'PAYPAL_TREMENDOUS',
  PAYPAL_TREMENDOUS_INTERNATIONAL: 'PAYPAL_TREMENDOUS_INTERNATIONAL',
  PHYSICALDEBITATMCARD_BLACKHAWK_MASTERCARD: 'PHYSICALDEBITATMCARD_BLACKHAWK_MASTERCARD',
  PHYSICALDEBITCARD_BLACKHAWK_MASTERCARD: 'PHYSICALDEBITCARD_BLACKHAWK_MASTERCARD',
  STARBUCKS: 'EGIFT_BLACKHAWK_STARBUCKS',
  TARGET: 'EGIFT_BLACKHAWK_TARGET',
  VENMO: 'PAYPAL_VENMO',
  VENMO_DASH: 'VENMO_DASH',
  VENMO_TREMENDOUS: 'VENMO_TREMENDOUS',
  VIRTUALDEBITCARD_DASH_MASTERCARD: 'VIRTUALDEBITCARD_DASH_MASTERCARD',
  VIRTUALDEBITCARD_TREMENDOUS_MASTERCARD: 'VIRTUALDEBITCARD_TREMENDOUS_MASTERCARD',
};

export const PAYFLOWS = {
  EMAIL: 'email',
  FORM: 'form',
  MAIL: 'mail',
  OAUTH: 'oauth',
  OCT: 'oct',
};

export const FLOW_TYPES = {
  VALIDATE_PAYMENT: {
    URL_VALIDATION: 'url-validation',
  },
  RECIPIENT_LOGIN: {
    OAUTH: 'oauth',
    AUTO_LOGIN: 'auto-login',
    FINIX: 'finix',
    FORM: 'form',
    TWO_FACTOR: 'two-factor',
    COLLECT_ADDRESS: 'collect-address',
    COLLECT_ACH_DETAILS: 'collect-ach-details',
    COLLECT_ACH_DETAILS_STREET_ADDRESS: 'collect-ach-details-street-address',
  },
  ACCEPT_PAYMENT: {
    AUTO_ACCEPT: 'auto-accept',
    SELECT_CURRENCY: 'select-currency',
    BASIC: 'basic',
    COLLECT_ADDRESS: 'collect-address',
    CONFIRM_ACH_DETAILS: 'confirm-ach-details',
  },
};

const SYSTEM_PAYMENT_STATUSES = {
  COMPLETE: 'COMPLETE',
  ACCEPTED: 'ACCEPTED',
  READY_TO_SEND: 'READY_TO_SEND',
  SENDING: 'SENDING',
  READY_MANUAL: 'READY_MANUAL',
  PENDING_ACCEPTANCE: 'PENDING_ACCEPTANCE',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  ARCHIVED: 'ARCHIVED',
  RETURNED: 'PAYMENT_NETWORK_RETURNED',
  REFUNDED: 'PAYMENT_NETWORK_REFUNDED',
  ONHOLD: 'ONHOLD',
};

const UI_PAYMENT_STATUSES = {
  POLLING: 'POLLING',
};

export const PAYMENT_STATUSES = {
  ...SYSTEM_PAYMENT_STATUSES,
  ...UI_PAYMENT_STATUSES,
};

export const ERROR_TYPES = {
  UI_ERRORS: {
    UNCAUGHT_EXCEPTION: 'UI_UNCAUGHT_EXCEPTION',
    MALFORMED_PAYWALL_URL: 'malformedPaywallUrl',
    CANCELLED_PAYMENT: 'cancelledPayment',
    EXPIRED_PAYMENT: 'expiredPayment',
    ARCHIVED_PAYMENT: 'archivedPayment',
    FAILED_PAYMENT: 'failedPayment',
    OAUTH_DECLINED: 'oauthDeclined',
    PAYMENT_RETURNED: 'paymentReturned',
    PAYMENT_REFUNDED: 'paymentRefunded',
    OCT_ERROR: 'octError',
    HEALTH_CHECK: 'healthCheck',
    MISSING_API_KEY: 'missingApiKey',
  },
  urlCredentialError: 'urlCredentialError',
  VALIDATION_ATTEMPTS: 'validationAttempts',
  fetchPaymentInfoError: 'fetchPaymentInfoError',
  fetchProgramConfiguration: 'fetchProgramConfiguration',
  fetchPaymentAccounts: 'fetchPaymentAccounts',
  acceptPaymentTimeout: 'acceptPaymentTimeout',
  failedPayment: 'failedPayment',
  expiredPayment: 'expiredPayment',
  cancelledPayment: 'cancelledPayment',
  archivedPayment: 'archivedPayment',
  acceptPayment: 'acceptPayment',
  recipientLogin: 'recipientLogin',
  default: 'default',
  unknownError: 'unknownError',
  suspectedFirewall: 'suspectedFirewall',
  oauthDeclined: 'oauthDeclined',
};

export const MAP_PAYMENT_STATUS_TO_UI_ERROR_TYPE = {
  [SYSTEM_PAYMENT_STATUSES.CANCELLED]: ERROR_TYPES.UI_ERRORS.CANCELLED_PAYMENT,
  [SYSTEM_PAYMENT_STATUSES.EXPIRED]: ERROR_TYPES.UI_ERRORS.EXPIRED_PAYMENT,
  [SYSTEM_PAYMENT_STATUSES.ARCHIVED]: ERROR_TYPES.UI_ERRORS.ARCHIVED_PAYMENT,
  [SYSTEM_PAYMENT_STATUSES.FAILED]: ERROR_TYPES.UI_ERRORS.FAILED_PAYMENT,
  [SYSTEM_PAYMENT_STATUSES.RETURNED]: ERROR_TYPES.UI_ERRORS.PAYMENT_RETURNED,
  [SYSTEM_PAYMENT_STATUSES.REFUNDED]: ERROR_TYPES.UI_ERRORS.PAYMENT_REFUNDED,
};

export const HTTP_REQUEST_TYPES = {
  DEFAULT: 'default',
  HEALTH_CHECK_FAILED: 'healthCheckFailed',
  VALIDATION_ATTEMPTS: 'validationAttempts',
  FETCH_PAYMENT: 'fetchPayment',
  FETCH_PROGRAM_CONFIGURATION: 'fetchProgramConfiguration',
  FETCH_PAYMENT_ACCOUNTS: 'fetchPaymentAccounts',
  ACCEPT_PAYMENT: 'acceptPayment',
  RECIPIENT_LOGIN: 'recipientLogin',
  CURRENCY_CONVERSIONS: 'currencyConversions',
};

export const HTTP_ENDPOINTS = {
  VALIDATION_ATTEMPTS: 'validationAttempts',
};

export const BROWSER_STORAGE_ITEMS = {
  INITIAL_COMPLETE: 'initialComplete',
  OAUTH_CACHED_APPLICATION_STATE: 'applicationState',
  OAUTH_PAYWALL_URL: 'paywallUrl',
  SEEN_SYSTEM_NOTIFICATIONS: 'seenSystemNotifications',
  ACH_DETAILS_FORM_VALUES: 'achDetailsFormValues',
  ADDRESS_FORM_VALUES: 'addressFormValues',
};

// export const CACHED_FUNCTION_NAMES = {
//   REFRESH_VALIDATION_TOKEN: 'REFRESH_VALIDATION_TOKEN',
// };

export const ACTION_TYPES = {
  SET_HEALTH_CHECK_PASSED_OR_NOT_REQUIRED:
    'SET_HEALTH_CHECK_PASSED_OR_NOT_REQUIRED',
  FORCE_RE_RENDER: 'FORCE_RE_RENDER',
  START_OVER: 'START_OVER',
  MODALS: {
    PUSH: 'PUSH_MODAL',
    POP: 'POP_MODAL',
    SHOW_FAQS: 'SHOW_FAQS',
    SHOW_ERROR_MODAL: 'SHOW_ERROR_MODAL',
    SHOW_HTTP_ERROR_MODAL: 'SHOW_HTTP_ERROR_MODAL',
  },
  CONFIGURATION: {
    UPDATE: 'UPDATE_CONFIGURATION',
  },
  SELECTED_PAYMENT_NETWORK: {
    SET: 'SET_SELECTED_PAYMENT_NETWORK',
    RESET: 'RESET_SELECTED_PAYMENT_NETWORK',
  },
  ACCOUNTS: {
    SET: 'SET_ACCOUNTS',
  },
  TOKENS: {
    SET: 'SET_TOKEN',
    RESET: 'RESET_TOKEN',
  },
  PAYMENT: {
    SET: 'SET_PAYMENT',
    UPDATE: 'UPDATE_PAYMENT',
  },
  CACHED_FUNCTIONS: {
    SET: 'SET_CACHED_FUNCTION',
    REMOVE: 'REMOVE_CACHED_FUNCTION',
  },
  SHARED_STATE: {
    SET: 'SET_SHARED_STATE',
    RESET: 'RESET_SHARED_STATE',
  },
};

export const TOKEN_TYPES = {
  VALIDATE_PAYMENT: 'validatePayment',
  RECIPIENT_LOGIN: 'recipientLogin',
};

export const MAP_PAYMENT_STATUS_TO_CONFIG_KEY = {
  COMPLETE: 'paymentComplete',
  ACCEPTED: 'paymentComplete',
  READY_TO_SEND: 'paymentComplete',
  SENDING: 'paymentComplete',
  READY_MANUAL: 'paymentComplete',
  PENDING_ACCEPTANCE: 'acceptPayment',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  ARCHIVED: 'ARCHIVED',
  POLLING: 'pollingForComplete',
  PENDING_TRANSACTION: 'pendingTransaction',
};

export const LOG_LEVELS = {
  LOG: 'LOG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
};

export const CURRENCY_SELECTORS = {
  RECIPIENT: 'RECIPIENT',
  CUSTOMER: 'CUSTOMER',
};

export const CURRENCY_OPTIONS = [
  {
    value: 'USD',
    label: 'United States dollar',
  },
  {
    value: 'AUD',
    label: 'Australian dollar',
  },
  {
    value: 'CAD',
    label: 'Canadian dollar',
  },
  {
    value: 'CZK',
    label: 'Czech koruna',
  },
  {
    value: 'EUR',
    label: 'Euro',
  },
  {
    value: 'ILS',
    label: 'Israeli new shekel',
  },
  {
    value: 'JPY',
    label: 'Japanese yen',
  },
  {
    value: 'NZD',
    label: 'New Zealand dollar',
  },
  {
    value: 'PHP',
    label: 'Philippine peso',
  },
  {
    value: 'PLN',
    label: 'Polish złoty',
  },
  {
    value: 'GBP',
    label: 'Pound sterling',
  },
  {
    value: 'SGD',
    label: 'Singapore dollar',
  },
  {
    value: 'SEK',
    label: 'Swedish krona',
  },
  {
    value: 'CHF',
    label: 'Swiss franc',
  },
].reduce(
  (options, option) => ({ ...options, [option.label]: option.value }),
  {}
);

export const LOGGING = {
  EVENTS: {
    PAYWALL_VISITED: 'PAYWALL_VISITED',
    HEALTH_CHECK_FAILED: 'HEALTH_CHECK_FAILED',
    VALIDATION_ATTEMPT_SUCCEEDED: 'VALIDATION_ATTEMPT_SUCCEEDED',
    VALIDATION_ATTEMPT_FAILED: 'VALIDATION_ATTEMPT_FAILED',
    FETCH_PAYMENT_FAILED: 'FETCH_PAYMENT_FAILED',
    FETCH_PAYMENT_ACCOUNTS_FAILED: 'FETCH_PAYMENT_ACCOUNTS_FAILED',
    FETCH_PROGRAM_CONFIGURATION_FAILED: 'FETCH_PROGRAM_CONFIGURATION_FAILED',
    FAQS_OPENED: 'FAQS_OPENED', // track how often FAQs are being used
    FAQS_CLOSED: 'FAQS_CLOSED',
    FAQ_ITEM_EXPANDED: 'FAQ_ITEM_EXPANDED', // will include details of the specific faq question that is viewed; if we find that an FAQ question is viewed frequently, we can either move it to the top of the list or if we suspect widespread confusion we can consider including information about that question in the notification emails/sms that are sent to recipients
    MISSING_QUERY_PARAMS: 'MISSING_QUERY_PARAMS',
    PAYWALL_DISABLED_NETWORK_CLICKED: 'PAYWALL_DISABLED_NETWORK_CLICKED',
    PAYWALL_OPTION_EXPANDED: 'PAYWALL_OPTION_EXPANDED',
    PAYWALL_OPTION_COLLAPSED: 'PAYWALL_OPTION_COLLAPSED',
    PAYWALL_OPTION_SELECTED: 'PAYWALL_OPTION_SELECTED', // a user clicked 'proceed' on a paywall option, and likely has the intention of receiving their payment on the selected network
    PAYMENT_NETWORK_ABANDONED: 'PAYMENT_NETWORK_ABANDONED', // could be due to repeated errors on attempted payment acceptance, or the user decides to switch networks after viewing the information given on the the payment confirm acceptance screen
    RECIPIENT_LOGIN_ATTEMPTED: 'RECIPIENT_LOGIN_ATTEMPTED',
    RECIPIENT_LOGIN_SUCCEEDED: 'RECIPIENT_LOGIN_SUCCEEDED',
    RECIPIENT_LOGIN_FAILED: 'RECIPIENT_LOGIN_FAILED',
    UNEXPECTED_AUTOCOMPLETE_RESPONSE: 'UNEXPECTED_AUTOCOMPLETE_RESPONSE',
    OAUTH_DECLINED: 'OAUTH_DECLINED',
    PAYMENT_ACCEPTANCE_ATTEMPTED: 'PAYMENT_ACCEPTANCE_ATTEMPTED', // regardless of the outcome of the operation, suggests that a user intends to collect their payment on a given network
    PAYMENT_ACCEPTANCE_RESULT: 'PAYMENT_ACCEPTANCE_RESULT', // given the async nature of our transactions, not bothering to track successes/failures as their are transitional states and the user may not be on the paywall when those events occur
    PAYMENT_ACCEPTANCE_ERROR: 'PAYMENT_ACCEPTANCE_ERROR',
    LANGUAGE_SELECTOR_OPENED: 'LANGUAGE_SELECTOR_OPENED', // track how often language selector is being used
    LANGUAGE_CHANGED: 'LANGUAGE_CHANGED', // track if other languages are being used
    UNSUPPORTED_BROWSER: 'UNSUPPORTED_BROWSER',
  },
};

export const PAYMENT_NETWORK_RECIPIENT_TYPES = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};

export const PROGRAMS = {
  JETBLUE_CUSTOMER_COMMITMENT: 'JetBlue Customer Commitment',
  JETBLUE_BAGGAGE: 'JetBlue Baggage',
  CHAMELEON_CONSUMER: 'Chameleon Consumer',
  ADVANCED_DISPOSAL: 'Advanced Disposal',
  VIZIO: 'Vizio Settlement',
  JETBLUE_CUSTOMER_REFUNDS: 'JetBlue Customer Refunds',
  DIGITAL_PAY_SALES_CAMPAIGN: 'Digital Pay Sales Campaign',
  EQUIFAX_SETTLEMENT: 'Indiana Equifax Settlement',
  GARVIN: 'Garvin San Diego Settlement',
  SHUTTERFLY: 'Shutterfly Settlement',
  CT_AGO: 'CT AGO',
  PROPANE: 'Propane',
  BOUGHT_MILK: 'Bought Milk',
  AMERICAN_WEB_LOANS: 'American Web Loans',
  OPTICAL_DISK_DRIVE: 'Optical Disk Drive Settlement',
  BATTERIES: 'Lithium-Ion Batteries Settlement',
  EPIPEN: 'EpiPen',
  SUN_COUNTRY: 'Sun Country',
  OHIO_ELECTRICITY: 'Ohio Electricity Litigation',
};

export const TEST_PROGRAMS = pick(PROGRAMS, [
  'OHIO_ELECTRICITY',
  'JETBLUE_CUSTOMER_COMMITMENT',
  'SUN_COUNTRY',
  'EPIPEN',
  'BATTERIES',
  'OPTICAL_DISK_DRIVE',
  'DIGITAL_PAY_SALES_CAMPAIGN',
  'GARVIN',
  'SHUTTERFLY',
  'CT_AGO',
  'PROPANE',
  'BOUGHT_MILK',
  'AMERICAN_WEB_LOANS',
]);
